<template>
  <div class="notice">
    <div class="caption">參加「全家福寫真」抽獎注意事項</div>
    <ul>
      <li>
        <span>※</span>
        <span> 參加拍照人數限6人以內(需含國小 一 ~ 四 年級小朋友)。 </span>
      </li>
      <li>
        <span>※</span>
        <span>
          拍攝寫真照片需同意無償，並永久授權「可爾必思」品牌系列產品活動宣傳使用。
        </span>
      </li>
      <li>
        <span>※</span>
        <span style="word-wrap: break-word">
          此獎項需提供家族合照，照片請寄至 Email:<a
            href="mailto:happycalpistw@mail.asahisoftdrinks.com.tw"
            >happycalpistw@mail.asahisoftdrinks.com.tw</a
          >。
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import './ExchangePrizesNotice.scss';
</style>
